import fetcher, { fetchWithSharedCache, fetchAsObservable } from 'fetcher!sofe';
import canopyUrls from 'canopy-urls!sofe';
import { property } from 'lodash';
import { catchAsyncStacktrace } from 'auto-trace';
import { pluck } from 'rxjs/operators';

export function fetchClients() {
  let jql = [
    {
      field: 'is_archived',
      operator: 'eq',
      value: false,
    },
  ];
  return fetcher(`${canopyUrls.getWorkflowUrl()}/api/contacts?jql=${encodeURIComponent(JSON.stringify(jql))}&portal=1`)
    .then(resp => resp.json())
    .then(property("contacts"))
    .catch(catchAsyncStacktrace());
}

export function getWithCacheWhiteLabelSettings() {
  return fetchWithSharedCache('/white-label-settings', '#/')
}

export function getTaxReturns(clientId) {
  return fetchAsObservable(`/clients/${clientId}/client-returns`)
  .pipe(
    pluck("client-returns")
  );
}
